import React from 'react'
import "../styles/pelvicCareProgram.css";
import Evelyn from "../img/evelyn_profile_picture.png"

export const PelvicProgramBanner6 = () => {
  return (
    <div className="pelvic-program-banner-6">
      <h1 className="text-center text-al mb-4 fs-48-28">
        Meet your Coach: Evelyn Hecht, PT
      </h1>
      <div className="d-flex justify-content-center w-100">
        <img className="evelyn-circle" src={Evelyn} alt="evelyn-picture" />
      </div>
      <div className="mt-4">
        <p className="text-center text-dm fs-banner-5-text-20-16 fw-light">
          Evelyn has personally treated over 15,000 women as a Master Clinician
          of Pelvic Physical Therapy. She{' '}<br className="br-desktop-only" />
           created PelvicSense to help you achieve optimum pelvic health in the
          comfort of your home.
        </p>
        <p className="text-center text-dm fs-banner-5-text-20-16 fw-light">
          Her online program provides the know-how you need: education, calming
          mind exercises, and gentle{' '}<br className="br-desktop-only"/>
          progressive body exercise videos - to help bring you pelvic peace.
        </p>
      </div>
    </div>
  )
}
